import React, { useCallback, useState } from 'react'
import { IUserListActionConfirmation } from 'src/components/item_segment/layouts/profiles_list/model'
import MessageBoxModal from 'src/components/message_box/message_box_with_modal'
import { textResources } from 'src/lang/de'
import {
  GroupDetailFragmentFragment,
  GroupPreviewFragmentFragment,
  useDestroyGroupParticipationMutation
} from '@lopo-tech/lopo-api'
import { MSGBOX_BUTTON_TYPE_CANCEL, MSGBOX_BUTTON_TYPE_DANGER } from 'src/components/message_box/message_box'
import { showSnackBar } from 'src/components/snack_bar/snack_bar'
import type { ApolloError } from '@apollo/client'

type IGroup = GroupPreviewFragmentFragment | GroupDetailFragmentFragment
const labels = textResources.groups

export const useGroupLeaveConfirmation = () => {
  const [messageBoxModalProps, setMessageBoxModalProps] = useState<IUserListActionConfirmation | null>()
  const [destroyGroupParticipation] = useDestroyGroupParticipationMutation()

  const leaveGroup = useCallback(
    async (group: IGroup): Promise<void> => {
      if (!group?.ownGroupParticipation) return
      try {
        await destroyGroupParticipation({
          variables: { input: { id: group.ownGroupParticipation.id } }
        })
        showSnackBar(labels.leaveGroupSuccess(group.name))
      } catch (err) {
        showSnackBar(labels.leaveGroupError(group.name))
        console.error('leaveGroup error', err as ApolloError)
      }
    },
    [destroyGroupParticipation]
  )

  const onGroupLeave = (group: IGroup, onConfirm?: () => void) => {
    setMessageBoxModalProps({
      buttons: [
        {
          label: textResources.groups.leaveGroupModal.confirm,
          onClick: () => {
            setMessageBoxModalProps(null)
            leaveGroup(group).then(() => {
              if (onConfirm) onConfirm()
            })
          },
          type: MSGBOX_BUTTON_TYPE_DANGER
        },
        {
          label: textResources.shared.cancel,
          onClick: () => {
            setMessageBoxModalProps(null)
          },
          type: MSGBOX_BUTTON_TYPE_CANCEL
        }
      ],
      children: textResources.groups.leaveGroupModal.message,
      title: textResources.groups.leaveGroupModal.title_WEB(group.name),
      hideCloseButton: true
    })
  }

  return {
    LeaveConfirmationModal: messageBoxModalProps
      ? () => <MessageBoxModal {...messageBoxModalProps} hideCloseButton>{messageBoxModalProps.children}</MessageBoxModal>
      : null,
    onGroupLeave
  }
}
